import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { listStores } from '@/lib/api/stores.js';
import { useAuthStore } from '@/stores/auth.js';

/**
 * Single source of truth for multi-store UI.
 * True when the tenant has more than one active store
 * (updates automatically when stores list changes, e.g. second store added).
 */
export function useMultiStore(): {
  isMultiStore: boolean;
  activeStoreCount: number;
  isLoading: boolean;
} {
  const user = useAuthStore((s) => s.user);
  const storesQuery = useQuery({
    queryKey: ['stores-list'],
    queryFn: listStores,
    enabled: Boolean(user),
    staleTime: 30_000,
  });

  const activeStoreCount = useMemo(
    () => (storesQuery.data ?? []).filter((s) => s.active).length,
    [storesQuery.data],
  );

  return {
    isMultiStore: activeStoreCount > 1,
    activeStoreCount,
    isLoading: storesQuery.isLoading,
  };
}
